import React from 'react';
import FormCard from '../../../../../../components/FormCard';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import SmallerSpinner from '../../../../../../components/SmallerSpinner';

import ExpiryDisplay from '../../presentational/ExpiryDisplay';
import DrugSearchInputClean from '../../DrugSearchInputClean.jsx';
import styles from '../../../../css/inventoryItemDetail.module.css';

export default function FSPackCategoryCard({ f, exp, errors = {}, categories = [], plusShift = false }) {
  const baseCategories = Array.isArray(categories) ? categories : [];
  const unique = Array.from(new Set(baseCategories));

  let categoryOptions =
    f.category && f.category !== 'Other' && !unique.includes(f.category)
      ? [f.category, ...unique]
      : unique;

  // Always ensure "Other" is present exactly once at the end
  categoryOptions = [
    ...categoryOptions.filter(opt => String(opt) !== 'Other'),
    'Other',
  ];

  // Custom search function for categories
  const searchCategories = (term) => {
    const filtered = categoryOptions.filter(option =>
      String(option).toLowerCase().includes(term.toLowerCase())
    );
    return filtered.map(option => ({
      sku: option,
      name: option,
      categoryName: option
    }));
  };

  return (
    <FormCard>
      <FormRow className={styles.row}>
        <Field label="Pack Size" error={errors?.packsize}>
          <input
            className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
            type="text"
            value={f.packSize}
            onChange={e => f.setPackSize(e.target.value)}
            placeholder="e.g. 30, 100"
          />
        </Field>
        <Field
          label="Category"
          className={`${styles.compactField} ${styles.frontShopCategoryFixedWidthField}`}
          error={errors?.category}
        >
          <DrugSearchInputClean
            id="frontshop-category-search"
            initialValue={f.category || ''}
            placeholder="Search category"
            searchBackend={searchCategories}
            getDisplayValue={(item) => item?.name || ''}
            dropdownOnly={true}
            openDropdownOnFocus={true}
            minSearchLength={0}
            onSelect={(item) => {
              const category = item?.name || '';
              f.setCategory(category);
              if (category !== 'Other') {
                f.setCustomCategory('');
              }
            }}
            size="default"
            borderRadius="8px"
            length="370px"
            arrowInside={true}
            noResultsMessage="No categories found"
          />














        </Field>
        <Field label={f.category === 'Other' ? 'Other Category' : ''} error={errors?.category}>
          {f.category === 'Other' && (
            <input
              className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
              type="text"
              value={f.customCategory}
              onChange={e => f.setCustomCategory(e.target.value)}
              placeholder="Enter category"
            />
          )}
        </Field>
      </FormRow>
      <FormRow className={styles.row}>
        <Field label="Reorder Level" className={styles.compactField} error={errors?.reorderlevel}>
          <div className={styles.spinnerCenterRow}>
            <SmallerSpinner
              compact
              value={f.reorderLevel}
              onChange={f.setReorderLevel}
              className={`${styles.nudgeSpinnerFS} ${plusShift ? styles.nudgeSpinnerFSFlush : ''}`}
            />
          </div>
        </Field>
        <Field label="Quantity" className={styles.compactField} error={errors?.quantity}>
          <div className={styles.spinnerCenterRow}>
            <SmallerSpinner
              compact
              value={f.quantity}
              onChange={f.setQuantity}
              className={`${styles.nudgeSpinnerFS} ${plusShift ? styles.nudgeSpinnerFSFlush : ''}`}
            />
          </div>
        </Field>
        <Field label="Expiry Date" error={errors?.expirydates}>
          <ExpiryDisplay
            styles={styles}
            value={exp.expiryDisplay}
            onOpen={() => exp.setShowExpiryModal(true)}
          />
        </Field>
      </FormRow>
    </FormCard>
  );
}